import { useCallback, useReducer } from 'react';
import { usePodpowiedziMiejsc, type Szukaj } from '@/hooks/useBliskoDo';
import { POCZATEK_POLA, czyWierszMiejsca, frazaMiejsca, stanPola } from '@/lib/miejsceWPolu';

/**
 * Stan pola obszaru z trybem miejsc (plan §1.90) — wspólny dla pola na pulpicie i nakładki na
 * telefonie. Wyszukiwanie idzie TĄ SAMĄ ścieżką, co „Blisko do…” (`usePodpowiedziMiejsc` →
 * `szukajMiejsc` → funkcja `place-autocomplete`), ale dostaje frazę dopiero po wybraniu wiersza
 * „Szukaj miejsca”; do tej pory dostaje pusty napis, więc nie woła niczego.
 */
export function useMiejsceWPolu(szukaj?: Szukaj) {
  const [stan, wyslij] = useReducer(stanPola, POCZATEK_POLA);
  const wyniki = usePodpowiedziMiejsc(frazaMiejsca(stan), szukaj);
  return {
    query: stan.query,
    trybMiejsca: stan.trybMiejsca !== null,
    wierszMiejsca: czyWierszMiejsca(stan.query),
    pisz: useCallback((query: string) => wyslij({ typ: 'pisze', query }), []),
    szukajMiejsca: useCallback(() => wyslij({ typ: 'szukaj_miejsca' }), []),
    wroc: useCallback(() => wyslij({ typ: 'wroc' }), []),
    wyczysc: useCallback(() => wyslij({ typ: 'wybrano' }), []),
    places: wyniki.places,
    status: wyniki.status,
    laduje: wyniki.laduje,
  };
}
